import axios from 'axios';

const windowEnv = window['ENV'];
let apiHost = '';

if (windowEnv) {
  apiHost = `${windowEnv['REACT_APP_API_HOST']}`;
} else {
  apiHost = `${process.env.REACT_APP_API_HOST}`;
}

const instance = axios.create({
  baseURL: apiHost,
  timeout: 30000,
});

export default instance;
